/* ==========================================================================
 * Hot Box Pretzels — Scratch & Win pop-up  (Shopify theme `assets/custom.js`)
 * -----------------------------------------------------------------------------
 * This is the REWIRED version of the pop-up that lives in the Shopify theme
 * "Scratch & Win Popup — DRAFT". It is identical in look + behaviour to the
 * original, with ONE change: it no longer posts signups to Klaviyo. Instead it
 * POSTs to the Pretzel backend (`captureLead` Cloud Function), which:
 *   - stores the lead + per-channel consent,
 *   - sends the welcome email with the discount code via RESEND,
 *   - sends the optional SMS via Twilio,
 *   - returns the discount code (used to auto-apply on "Shop now").
 *
 * To deploy: replace the theme's `assets/custom.js` with this file
 * (Online Store → Themes → ⋯ Edit code → assets/custom.js → paste → Save).
 * The discount code + welcome email copy are configured in the dashboard:
 * Marketing → Popup builder (writes popupConfigs/default). Prize shown = "10% OFF",
 * code delivered = whatever popupConfigs.discountCode is set to (e.g. SCRATCH10).
 * ===========================================================================*/
(function () {
"use strict";
if (window.__hbpLoaded) return;
window.__hbpLoaded = true;
var CFG = {
LOGO_URL:  "https://cdn.shopify.com/s/files/1/0578/6897/6192/files/hbp-popup-logo.png?v=1780364061",
PHOTO_URL: "https://cdn.shopify.com/s/files/1/0578/6897/6192/files/hbp-popup-photo.jpg?v=1780362916", // oven+pretzels background (embedded)
CAPTURE_ENDPOINT: "https://us-central1-pretzel-business.cloudfunctions.net/captureLead", // Pretzel backend -> Resend email + Twilio SMS
TRACK_ENDPOINT:   "https://us-central1-pretzel-business.cloudfunctions.net/trackStorefrontEvent", // anonymous popup_view beacon -> popupAnalytics.views
CONFIG_ENDPOINT:  "https://us-central1-pretzel-business.cloudfunctions.net/popupConfig",          // A/B variants: traffic split + per-variant copy
STORE_ID:  "default",   // matches the popupConfigs/{storeId} doc in the dashboard
SOURCE:    "Scratch & Win Pop-Up",
DELAY_MS:  1500,
// Hard ceiling on how long the config fetch may hold the popup back. It starts at
// t=0 and the popup is not due until DELAY_MS, so in practice it is already home;
// this only bounds the pathological case. On timeout the popup opens with its
// built-in copy and NO variant — an unassigned impression, not a missing one.
CONFIG_TIMEOUT_MS: 2500
};
if (window.HBP_PHOTO_URL) CFG.PHOTO_URL = window.HBP_PHOTO_URL;
if (window.HBP_LOGO_URL)  CFG.LOGO_URL  = window.HBP_LOGO_URL;
var photoLayer = CFG.PHOTO_URL
? "url('" + CFG.PHOTO_URL + "') center bottom / cover no-repeat, #00070E"
: "radial-gradient(120% 90% at 50% 120%, #15202b 0%, #00070E 60%)";
var CSS = [
"#hbpOverlay{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:16px;background:rgba(0,3,8,.72);opacity:1;transition:opacity .28s ease;font-family:'TAY Milkbar','Baloo 2','Arial Black',sans-serif}",
"#hbpOverlay[aria-hidden='true']{opacity:0;pointer-events:none}",
"#hbpOverlay *{box-sizing:border-box}",
".hbp-pop{position:relative;width:min(92vw,420px);min-height:min(640px,92vh);max-height:94vh;display:flex;flex-direction:column;background:#00070E;border-radius:16px;overflow:hidden;box-shadow:0 30px 80px rgba(0,0,0,.6)}",
".hbp-photo{position:absolute;inset:0;z-index:0;background:" + photoLayer + "}",
".hbp-photo::after{content:'';position:absolute;inset:0;background:linear-gradient(to bottom,rgba(0,7,14,.93) 0%,rgba(0,7,14,.8) 20%,rgba(0,7,14,.5) 42%,rgba(0,7,14,.26) 60%,rgba(0,7,14,.24) 80%,rgba(0,7,14,.46) 100%)}",
".hbp-content{position:relative;z-index:2;flex:1 1 auto;display:flex;flex-direction:column;align-items:center;text-align:center;padding:26px 26px 34px;overflow:auto}",
".hbp-close{position:absolute;top:10px;right:12px;z-index:5;width:30px;height:30px;border-radius:50%;border:0;cursor:pointer;line-height:1;font-size:20px;color:#FFF4B3;background:rgba(255,244,179,.14)}",
".hbp-logo{width:62%;max-width:240px;height:auto;margin:8px 0 16px;filter:drop-shadow(0 2px 6px rgba(0,0,0,.5))}",
".hbp-display{font-family:'TAY Sundae','Permanent Marker',cursive;font-weight:400;text-transform:uppercase;color:#FFF4B3;font-size:clamp(2.1rem,9vw,2.9rem);line-height:.98;margin:.1em 0 .35em;text-shadow:0 2px 8px rgba(0,0,0,.35)}",
".hbp-label{font-weight:700;text-transform:uppercase;letter-spacing:.085em;color:#fff;font-size:.82rem;line-height:1.35;margin:0 0 18px;max-width:26ch}",
// Variant copy slots that no variant fills collapse instead of leaving a gap.
".hbp-label:empty{display:none}",
".hbp-step{display:none;width:100%;flex-direction:column;align-items:center}",
"#hbpOverlay[data-step='scratch'] .hbp-step[data-step='scratch'],#hbpOverlay[data-step='email'] .hbp-step[data-step='email'],#hbpOverlay[data-step='sms'] .hbp-step[data-step='sms'],#hbpOverlay[data-step='success'] .hbp-step[data-step='success']{display:flex}",
".hbp-prize{display:flex;flex-direction:column;align-items:center;justify-content:center;line-height:1;user-select:none}",
".hbp-prize .t{font-weight:700;text-transform:uppercase;letter-spacing:.04em;color:#FFF4B3;font-size:1.15rem;margin-bottom:.18em}",
".hbp-prize .b{font-weight:800;text-transform:uppercase;color:#FFF4B3;font-size:clamp(2.6rem,13vw,3.4rem)}",
".hbp-prize.inline{margin:6px 0 22px}",
".hbp-ladder{display:none}",
".hbp-ladder.on{display:flex}",
".hbp-ladder .b{transition:transform .18s ease}",
".hbp-ladder.bump .b{transform:scale(1.12)}",
// The code chip on the success step. Dashed border + monospace so it reads as
// something to write down, and big enough to tap-to-copy on a phone (the popup
// is ~94% mobile).
".hbp-code{display:none;align-items:center;gap:.5em;margin:0 0 16px;padding:11px 16px;border:1.5px dashed rgba(255,244,179,.55);border-radius:8px;background:rgba(255,244,179,.07);cursor:pointer}",
".hbp-code.on{display:inline-flex}",
".hbp-code .v{font-family:ui-monospace,SFMono-Regular,Menlo,monospace;font-weight:800;letter-spacing:.12em;color:#FFF4B3;font-size:1.18rem}",
".hbp-code .c{font-weight:700;text-transform:uppercase;letter-spacing:.08em;color:rgba(255,244,179,.6);font-size:.62rem}",
".hbp-scratch{position:relative;width:100%;aspect-ratio:1.85/1;border-radius:12px;overflow:hidden;margin:2px 0 20px;background:#00070E}",
".hbp-scratch .hbp-prize{position:absolute;inset:0}",
".hbp-canvas{position:absolute;inset:0;width:100%;height:100%;touch-action:none;cursor:grab}",
".hbp-scratch.done .hbp-canvas{opacity:0;transition:opacity .45s ease;pointer-events:none}",
".hbp-form{width:100%;display:flex;flex-direction:column;gap:14px}",
".hbp-input{width:100%;border:0;border-radius:11px;background:#FFF4B3;color:#00070E;font-family:inherit;font-weight:700;text-transform:uppercase;letter-spacing:.04em;font-size:.95rem;padding:16px 18px}",
".hbp-input::placeholder{color:#00070E;opacity:.62}",
".hbp-input:focus{outline:3px solid #FBC232;outline-offset:1px}",
".hbp-btn{display:inline-flex;align-items:center;justify-content:center;width:100%;border:0;border-radius:11px;cursor:pointer;background:#FFF4B3;color:#00070E;font-family:inherit;font-weight:800;text-transform:uppercase;letter-spacing:.03em;font-size:1.12rem;padding:16px 18px;text-decoration:none;box-shadow:0 6px 0 rgba(0,0,0,.18)}",
".hbp-btn:active{transform:translateY(3px);box-shadow:0 3px 0 rgba(0,0,0,.18)}",
// Daniel Aug/11: the SMS button "a little smaller" — only this step's button.
".hbp-step[data-step=sms] .hbp-btn{font-size:1rem;padding:13px 16px}",
".hbp-claim.hide{display:none}",
".hbp-tel{display:flex;align-items:center;background:#FFF4B3;border-radius:11px;overflow:hidden}",
".hbp-cc{border:0;background:transparent;color:#00070E;font-family:inherit;font-weight:700;font-size:.95rem;padding:16px 4px 16px 14px;cursor:pointer}",
".hbp-phone{flex:1;background:transparent;border-radius:0;padding-left:8px}",
".hbp-consent{font-size:.62rem;line-height:1.4;color:rgba(255,255,255,.6);margin:12px 4px 0;text-align:center}",
".hbp-consent a{color:rgba(255,255,255,.85);text-decoration:underline}",
".hbp-skip{background:none;border:0;color:rgba(255,255,255,.55);text-decoration:underline;font-size:.78rem;cursor:pointer;font-family:inherit;margin-top:2px}"
,
"#hbpReopen{position:fixed;left:0;top:50%;transform:translateY(-50%);z-index:2147482000;writing-mode:vertical-rl;padding:15px 7px;border:0;border-radius:0 12px 12px 0;cursor:pointer;background:#FFF4B3;color:#0a0a0a;font-family:'TAY Milkbar','Baloo 2','Arial Black',sans-serif;font-size:12px;font-weight:700;letter-spacing:.11em;line-height:1;box-shadow:0 2px 16px rgba(0,0,0,.4)}",
"#hbpReopen[hidden]{display:none}",
"#hbpReopen:focus-visible{outline:3px solid #0a0a0a;outline-offset:2px}",
"@media (prefers-reduced-motion:no-preference){#hbpReopen{transition:transform .2s ease}#hbpReopen:hover{transform:translateY(-50%) translateX(3px)}}"
].join("");
var style = document.createElement("style");
style.id = "hbp-style";
style.textContent = CSS;
document.head.appendChild(style);
var overlay = document.createElement("div");
overlay.id = "hbpOverlay";
overlay.setAttribute("data-step", "scratch");
overlay.setAttribute("aria-hidden", "true");
overlay.setAttribute("role", "dialog");
overlay.setAttribute("aria-modal", "true");
overlay.innerHTML =
'<div class="hbp-pop">' +
'<button class="hbp-close" type="button" aria-label="Close">&times;</button>' +
'<div class="hbp-content">' +
'<img class="hbp-logo" alt="Hot Box Pretzels" src="' + CFG.LOGO_URL + '">' +
'<section class="hbp-step" data-step="scratch">' +
'<h2 class="hbp-display">Try Your Luck</h2>' +
'<p class="hbp-label">Scratch below to see what you win</p>' +
'<div class="hbp-scratch" id="hbpScratch">' +
'<div class="hbp-prize"><span class="t">You’ve got</span><span class="b">10% OFF</span></div>' +
'<canvas class="hbp-canvas" id="hbpCanvas"></canvas>' +
'</div>' +
'<button class="hbp-btn hbp-claim hide" type="button" data-next="email">Claim</button>' +
'</section>' +
'<section class="hbp-step" data-step="email">' +
'<div class="hbp-prize inline"><span class="t">You’ve got</span><span class="b">10% OFF</span></div>' +
// Empty by default (CSS collapses it) — exists so a variant can put a line above the
// email field without a theme push. Daniel's example variation uses the prize block
// above for "Claim 10% off"; this is the spare slot next to it.
'<p class="hbp-label" data-copy="emailLabel"></p>' +
'<form class="hbp-form" id="hbpForm" novalidate>' +
'<input class="hbp-input" type="email" name="email" inputmode="email" placeholder="Your email address" aria-label="Your email address" required>' +
'<button class="hbp-btn" type="submit">Continue</button>' +
'</form>' +
'</section>' +
'<section class="hbp-step" data-step="sms">' +
// Daniel Aug/7: "get the emails as the priority and reward the code". The old copy
// ("Finish signing up" / "For texts to activate 10% off" / "Activate 10% off") told
// people the phone number was what unlocked the discount. That is no longer true —
// every exit from this screen now sends the code — and it was the friction driving
// people off the step. Say the code is already theirs and let the phone be a bonus.
// Aug/16: the headline no longer NAMES the code. This step renders BEFORE captureLead
// has ever been called — the POST fires on submit / skip / close (see finishSignup) —
// so the screen cannot know the shopper's code yet, and "CE98" was only ever true
// while popupConfigs.uniqueCodes was off. During the Aug 7–10 window it was on, the
// backend minted per-visitor HB… codes, and 865 shoppers were shown a code that was
// not theirs. uniqueCodes is a dashboard toggle with no deploy, so this line must be
// true in BOTH modes: the real code is rendered one step later, on success, by
// applyCode() — chip + tap-to-copy + the auto-applying /discount/ link.
'<h2 class="hbp-display">Your code is locked in</h2>' +
'<p class="hbp-label">Enter your phone for VIP discounts you won’t find anywhere else. Totally optional.</p>' +
// Daniel Aug/8: the shopper should SEE the discount climb the moment they type a
// number. This block stays hidden unless the store actually configures a higher
// phone tier (popupConfig.tiers), so with a flat 10% the step looks exactly as it
// did. renderLadder() drives it; the real percent is still decided server-side.
'<div class="hbp-prize inline hbp-ladder"><span class="t">You’ve got</span><span class="b"></span></div>' +
'<form class="hbp-form" id="hbpFormSms" novalidate>' +
'<div class="hbp-tel">' +
'<select class="hbp-cc" aria-label="Country code">' +
'<option value="+1">🇺🇸 +1</option>' +
'<option value="+1">🇨🇦 +1</option>' +
'<option value="+44">🇬🇧 +44</option>' +
'<option value="+61">🇦🇺 +61</option>' +
'<option value="+353">🇮🇪 +353</option>' +
'<option value="+64">🇳🇿 +64</option>' +
'</select>' +
'<input class="hbp-input hbp-phone" type="tel" name="phone" inputmode="tel" placeholder="Your phone number" aria-label="Your phone number">' +
'</div>' +
'<button class="hbp-btn" type="submit">I’m In. Text Me</button>' +
'<button class="hbp-skip" type="button" data-skip>No thanks, email is fine</button>' +
'<p class="hbp-consent">By entering your number and tapping the button, you agree to receive recurring automated marketing texts (e.g. cart reminders) from Hot Box Pretzels at the number provided. Consent is not a condition of purchase. Msg &amp; data rates may apply. Msg frequency varies. Reply HELP for help, STOP to cancel. See our <a href="/policies/terms-of-service" target="_blank" rel="noopener">Terms</a> and <a href="/policies/privacy-policy" target="_blank" rel="noopener">Privacy Policy</a>.</p>' +
'</form>' +
'</section>' +
'<section class="hbp-step" data-step="success">' +
'<h2 class="hbp-display">You are in!</h2>' +
// Daniel Aug/8: put the code ON SCREEN. Until Aug/7 the code was the shared CE98,
// repeated in every welcome + reminder email, so leaving it off this screen cost
// nothing. A per-person single-use code has exactly ONE other copy — that email —
// and "check your email" walks them off the site at the single moment they were
// ready to buy. Both nodes below stay in their pre-Aug/8 state until applyCode()
// actually receives a code, so a backend failure degrades to the old screen
// rather than to an empty box promising a code that isn't there.
'<p class="hbp-label">Check your email to receive your discount code.</p>' +
'<div class="hbp-code"><span class="v"></span><span class="c">tap to copy</span></div>' +
// Daniel Aug/7 #1: "Shop Now" lands on All Flavors, not build-your-pretzel-box.
// /pages/all-flavors is what the nav labels "All Flavors" (verified against the live
// menu) and it is the box builder, so the code they just won is usable on arrival.
'<a class="hbp-btn" href="/pages/all-flavors">Shop now</a>' +
'</section>' +
'</div>' +
'<div class="hbp-photo"></div>' +
'</div>';
document.body.appendChild(overlay);
/* ── A/B variants ───────────────────────────────────────────────────────────
 * Daniel Aug/7: "What's the best way to test three or four new variations at the
 * same time?" One test, all arms live at once, traffic split per browser.
 *
 * Three rules this has to hold to, or the numbers are worthless:
 *
 *   1. ASSIGNMENT IS STICKY per browser. Re-rolling on every page view would mean
 *      one person counts as an impression for arm A and a signup for arm B, and
 *      every rate would be a blend of all four.
 *   2. THE SAME ID GOES ON THE VIEW BEACON AND ON THE SIGNUP. A conversion rate
 *      needs one label on both halves — the Aug/6 submissions-per-view vs
 *      per-session argument was exactly this mistake, on the whole popup.
 *   3. COPY COMES FROM THE CONFIG, NEVER FROM THIS FILE. Editing a headline must
 *      be a dashboard change, not a theme push waiting on someone's approval.
 *
 * Everything below fails OPEN: a slow, broken or missing config means the popup
 * shows exactly as it does today, with no variant on either payload. An unassigned
 * impression is honest — a missing one is not.
 * ------------------------------------------------------------------------- */
var VARIANT_KEY = "hbp_variant";
var variantId = null;      // the arm this browser is in, or null (not in the test)
var variantMem = null;     // last-resort store when both Web Storages are blocked

function readStored(k) {
  try { var v = localStorage.getItem(k); if (v) return v; } catch (e) {}
  try { var s = sessionStorage.getItem(k); if (s) return s; } catch (e) {}
  return null;
}
function writeStored(k, v) {
  try { localStorage.setItem(k, v); return; } catch (e) {}
  try { sessionStorage.setItem(k, v); } catch (e) {}
}

/**
 * Pick this browser's arm. `variants` is the server's list, already normalised into
 * cumulative upper bounds (see functions/src/popupVariants.ts) so the split is
 * decided and tested server-side, not re-derived here.
 *
 * A stored id that is no longer in the config (Daniel renamed or dropped an arm)
 * is re-rolled rather than kept — otherwise the browser would keep reporting into
 * a column nothing else writes to.
 */
function assignVariant(variants) {
  if (!variants || !variants.length) return null;
  var stored = variantMem || readStored(VARIANT_KEY);
  if (stored) {
    for (var i = 0; i < variants.length; i++) if (variants[i].id === stored) return stored;
  }
  var draw = Math.random();
  var chosen = variants[variants.length - 1].id;
  for (var j = 0; j < variants.length; j++) {
    if (draw < variants[j].upTo) { chosen = variants[j].id; break; }
  }
  variantMem = chosen;
  writeStored(VARIANT_KEY, chosen);
  return chosen;
}

// Where each copy slot lands. Anything a variant leaves out keeps the copy already
// in the markup above, so a half-filled variant is still a complete popup.
var COPY_SLOTS = {
  scratchHeadline:  ['.hbp-step[data-step="scratch"] .hbp-display', "text"],
  scratchLabel:     ['.hbp-step[data-step="scratch"] .hbp-label', "text"],
  scratchPrizeTop:  ["#hbpScratch .hbp-prize .t", "text"],
  scratchPrizeBig:  ["#hbpScratch .hbp-prize .b", "text"],
  scratchCta:       [".hbp-claim", "text"],
  emailPrizeTop:    ['.hbp-step[data-step="email"] .hbp-prize .t', "text"],
  emailPrizeBig:    ['.hbp-step[data-step="email"] .hbp-prize .b', "text"],
  emailLabel:       ['[data-copy="emailLabel"]', "text"],
  emailPlaceholder: ["#hbpForm .hbp-input", "placeholder"],
  emailCta:         ['#hbpForm button[type="submit"]', "text"],
  smsHeadline:      ['.hbp-step[data-step="sms"] .hbp-display', "text"],
  smsLabel:         ['.hbp-step[data-step="sms"] .hbp-label', "text"],
  smsPlaceholder:   [".hbp-phone", "placeholder"],
  smsCta:           ['#hbpFormSms button[type="submit"]', "text"],
  smsSkip:          ["[data-skip]", "text"],
  successHeadline:  ['.hbp-step[data-step="success"] .hbp-display', "text"],
  successLabel:     ['.hbp-step[data-step="success"] .hbp-label', "text"],
  successCta:       ['.hbp-step[data-step="success"] .hbp-btn', "text"]
};

/** Copy is written as TEXT and as a placeholder attribute only — never innerHTML,
 *  so a dashboard edit can never inject markup into the storefront. */
function applyCopy(copy) {
  if (!copy) return;
  for (var slot in COPY_SLOTS) {
    if (!Object.prototype.hasOwnProperty.call(copy, slot)) continue;
    var value = copy[slot];
    if (typeof value !== "string") continue;
    var spec = COPY_SLOTS[slot];
    var el = overlay.querySelector(spec[0]);
    if (!el) continue;
    if (spec[1] === "placeholder") {
      el.setAttribute("placeholder", value);
      el.setAttribute("aria-label", value);
    } else {
      el.textContent = value;
    }
  }
}

/**
 * Fetch the variant config and settle this browser into an arm. ALWAYS resolves —
 * a rejected promise here would mean no popup at all.
 */
function loadVariant() {
  return new Promise(function (resolve) {
    var done = false;
    var settle = function () { if (!done) { done = true; resolve(); } };
    // Independent of fetch: an endpoint that accepts the connection and then hangs
    // would never reject, and the popup would never open.
    setTimeout(settle, CFG.CONFIG_TIMEOUT_MS);
    try {
      fetch(CFG.CONFIG_ENDPOINT + "?storeId=" + encodeURIComponent(CFG.STORE_ID), {
        method: "GET",
        credentials: "omit"
      }).then(function (r) {
        return r.ok ? r.json() : null;
      }).then(function (data) {
        if (done || !data) return settle();
        // Read the ladder BEFORE the variants guard below — with no test running
        // `variants` is [] and an early return would drop the tiers on the floor.
        if (data.tiers && Number(data.tiers.email) > 0 && Number(data.tiers.phone) > 0) {
          TIERS = { email: Number(data.tiers.email), phone: Number(data.tiers.phone) };
        }
        if (!Array.isArray(data.variants) || !data.variants.length) return settle();
        variantId = assignVariant(data.variants);
        for (var i = 0; i < data.variants.length; i++) {
          if (data.variants[i].id === variantId) { applyCopy(data.variants[i].copy); break; }
        }
        settle();
      })["catch"](settle);
    } catch (e) { settle(); }
  });
}

// The 10 / 15 ladder, for DISPLAY. Defaults to a flat ladder so that until
// popupConfig says otherwise (or if the fetch fails) this screen behaves exactly as
// it did before Aug/8. captureLead re-derives the real percent from the phone that
// actually arrived, so nothing here can buy a bigger discount.
var TIERS = { email: 10, phone: 10 };
function ladderOn() { return TIERS.phone > TIERS.email; }

/**
 * Paint the SMS step for the rung the shopper is currently standing on.
 * `hasDigits` = they have typed something that looks like a number.
 * No-ops when a variant is running: that arm owns its own copy (applyCopy), and two
 * writers fighting over the same nodes is how copy ends up half from each.
 */
function renderLadder(hasDigits) {
  if (variantId || !ladderOn()) return;
  var sms = overlay.querySelector('.hbp-step[data-step="sms"]');
  if (!sms) return;
  var box = sms.querySelector(".hbp-ladder");
  var big = box && box.querySelector(".b");
  var pct = hasDigits ? TIERS.phone : TIERS.email;
  if (big) {
    var next = pct + "% OFF";
    if (big.textContent !== next) {
      big.textContent = next;
      // Only pulse on an actual change, so holding a key down doesn't strobe.
      box.classList.add("bump");
      setTimeout(function () { box.classList.remove("bump"); }, 200);
    }
    box.classList.add("on");
  }
  var label = sms.querySelector(".hbp-label");
  if (label) label.textContent = hasDigits
    ? "Nice — your code is now " + TIERS.phone + "% off."
    : "Add your number and we’ll make it " + TIERS.phone + "% off.";
  var cta = sms.querySelector('#hbpFormSms button[type="submit"]');
  if (cta) cta.textContent = hasDigits ? "Get my " + TIERS.phone + "% off" : "I’m In. Text Me";
  var skip = sms.querySelector("[data-skip]");
  if (skip) skip.textContent = "No thanks, I’ll keep " + TIERS.email + "%";
}

function setStep(s) { overlay.setAttribute("data-step", s); if (s === "sms") renderLadder(false); }
function open() { overlay.setAttribute("aria-hidden", "false"); trackView(); }
function close() {
overlay.setAttribute("aria-hidden", "true");
try { sessionStorage.setItem("hbp_closed", "1"); } catch (e) {}
// Daniel Aug/6: if they typed an email and then bailed on the phone screen we used
// to keep NOTHING — subscribe() only ran on the SMS submit or "No thanks", so they
// got no code, no welcome email, and no contact was stored. Worse, the email step
// had already flagged them "signed" in localStorage, so the popup never came back.
// Capture it here instead. `submitted` keeps it to exactly ONE captureLead call,
// because captureLead has no guard against sending the coupon email twice.
finishSignup({ email: captured.email, exit: true });
// finishSignup already set hbp_signed if an email was captured, so reopenAllowed()
// filters those people out on its own — this call is safe either way.
showReopener();
}
window.HBPPopup = { open: open, close: close, reopener: showReopener };
var captured = { email: "" };
var submitted = false;
// Single point of no return: whoever gets here first wins, everyone else no-ops.
function finishSignup(attrs) {
if (submitted || !attrs || !attrs.email) return null;
submitted = true;
// Only claim "already signed up" once the signup actually left the browser.
try { localStorage.setItem("hbp_signed", "1"); } catch (e) {}
return subscribe(attrs).then(applyCode);
}
// close() only runs on the X, the backdrop and Escape. Plenty of people leave the phone
// screen by closing the tab, hitting back, or just navigating away — none of which call
// close(), so the email would still be lost for them. pagehide covers unload; iOS Safari
// often skips pagehide, so visibilitychange:hidden is the one that actually fires there.
// Both are idempotent because finishSignup has the `submitted` latch.
function settleOnLeave() {
if (submitted || !captured.email) return;
finishSignup({ email: captured.email, exit: true });
}
window.addEventListener("pagehide", settleOnLeave);
document.addEventListener("visibilitychange", function () {
if (document.visibilityState === "hidden") settleOnLeave();
});

/* ---------------------------------------------------------------------------
 * Daniel Aug/16: a way BACK to the scratch-off.
 * Closing sets sessionStorage.hbp_closed and the popup never returns for the rest
 * of the session, so anyone who changed their mind was stuck with no route back.
 * This is a small edge tab shown ONLY after a close.
 *
 * LEFT edge on purpose: `.byob-bar` (the builder's cart bar) is position:fixed
 * bottom:0 full-width at z-index 45 on /pages/all-flavors — the busiest page on
 * the store — so anything bottom-anchored would sit on top of it. The left edge
 * is free on every template, so this needs no per-page collision math.
 *
 * z-index sits BELOW the overlay (2147483000) so the popup covers the tab when it
 * opens, and far above page chrome so nothing buries it.
 *
 * Deliberately hidden for anyone already signed up: close() itself calls
 * finishSignup(), so a shopper who typed an email before closing is flagged
 * `hbp_signed` synchronously — they already have their code and must not be
 * nagged to "win" it again.
 * ------------------------------------------------------------------------- */
var reopenBtn = null;
function reopenAllowed() {
if (window.Shopify && Shopify.designMode) return false;
if (window.HBP_DISABLE_POPUP) return false;                    // LP runs its own offer
try { if (localStorage.getItem("hbp_signed")) return false; } catch (e) {}
return true;
}
function showReopener() {
if (!reopenAllowed()) return;
if (!reopenBtn) {
reopenBtn = document.createElement("button");
reopenBtn.id = "hbpReopen";
reopenBtn.type = "button";
reopenBtn.textContent = "SCRATCH & WIN";
reopenBtn.setAttribute("aria-label", "Reopen the scratch and win discount offer");
reopenBtn.addEventListener("click", function () {
// Clear the session gate too, so a later page view doesn't slam it shut again.
try { sessionStorage.removeItem("hbp_closed"); } catch (e) {}
reopenBtn.setAttribute("hidden", "");
open();
if (overlay.__hbpSizeCanvas) overlay.__hbpSizeCanvas();
});
document.body.appendChild(reopenBtn);
}
reopenBtn.removeAttribute("hidden");
}

// Anonymous impression beacon — the DENOMINATOR the dashboard's popup panel has been
// missing all along (it reads popupAnalytics.views, which nothing was incrementing,
// so it showed 1 view and a nonsense 100% conversion). One per browser session; the
// backend also rate-limits per IP. Fire-and-forget — never blocks or delays the UI.
function trackView() {
try {
if (sessionStorage.getItem("hbp_viewed")) return;
sessionStorage.setItem("hbp_viewed", "1");
} catch (e) {}
try {
var beacon = { kind: "popup_view", storeId: CFG.STORE_ID };
// The A/B DENOMINATOR. Must carry the same id the signup will — a rate built from
// views labelled one way and signups labelled another is worse than no rate at all.
if (variantId) beacon.variant = variantId;
fetch(CFG.TRACK_ENDPOINT, {
method: "POST",
headers: { "Content-Type": "application/json" },
body: JSON.stringify(beacon),
keepalive: true
})["catch"](function () {});
} catch (e) {}
}
// Pretzel backend (captureLead): sends the welcome email via Resend + optional
// SMS via Twilio, and returns the authoritative discount code.
function subscribe(attrs) {
// Daniel Aug/7 wants to know how much of the 7-8% -> 5.7% gap this rescue accounts
// for. Tag the ones that would previously have been LOST (they left the phone screen
// without acting) with a distinct source, so they're countable against the normal
// finishes instead of being indistinguishable from them. Still matches the
// /popup|scratch/i test captureLead uses for its analytics rollup.
var payload = {
storeId: CFG.STORE_ID,
source: attrs.exit ? CFG.SOURCE + " (exit rescue)" : CFG.SOURCE,
smsConsent: attrs.phone ? true : false
};
if (attrs.email) payload.email = attrs.email;
if (attrs.phone) payload.phone = attrs.phone;
// The A/B NUMERATOR. This only NAMES the arm — the server decides what the code is
// worth (10% for the email, 15% once a phone lands) from the payload it can verify,
// so nothing here can ask for a bigger discount than the arm is configured for.
if (variantId) payload.variant = variantId;
return fetch(CFG.CAPTURE_ENDPOINT, {
method: "POST",
headers: { "Content-Type": "application/json" },
body: JSON.stringify(payload),
// keepalive is the whole point of the rescue below: the people we are trying to
// save are the ones who bail, and bailing usually means the page is going away.
// Without this the browser cancels the request on unload and the lead is lost
// anyway — the exact bug we think we just fixed.
keepalive: true
}).then(function (r) {
return r.json().catch(function () { return {}; }).then(function (data) {
if (!r.ok || data.ok === false) { console.warn("[HBP] captureLead error " + r.status, data); }
else { console.log("[HBP] captureLead OK", data); }
return data || {};
});
}).catch(function (e) { console.warn("[HBP] captureLead request failed", e); return {}; });
}
// If the backend returned a code: make "Shop now" auto-apply it AND show it.
// The button alone is not enough — it only helps the shopper who converts in this
// exact session. Rendering the code (and the percent it is actually worth, which
// the server decides — never a number the widget assumed) gives everyone else
// something they can still use tomorrow.
function applyCode(data) {
if (!data || !data.code) return;
var success = overlay.querySelector('.hbp-step[data-step="success"]');
if (!success) return;
try {
var shop = success.querySelector(".hbp-btn");
if (shop) shop.setAttribute("href", "/discount/" + encodeURIComponent(data.code) + "?redirect=/pages/all-flavors");
} catch (e) {}
try {
var pct = Number(data.percent) > 0 ? Number(data.percent) : null;
var label = success.querySelector(".hbp-label");
// textContent only — this string is server-supplied and must never be parsed as HTML.
if (label) label.textContent = pct
? "Here is your " + pct + "% off code. We emailed it to you too."
: "Here is your code. We emailed it to you too.";
var box = success.querySelector(".hbp-code");
var val = box && box.querySelector(".v");
if (box && val) {
val.textContent = data.code;
box.classList.add("on");
box.addEventListener("click", function () {
var note = box.querySelector(".c");
function done() { if (note) { note.textContent = "copied"; setTimeout(function () { note.textContent = "tap to copy"; }, 1600); } }
try {
if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(data.code).then(done, function () {}); return; }
} catch (e) {}
// No clipboard API (older mobile Safari, or a non-secure context): select the
// text so a long-press "Copy" still works instead of silently doing nothing.
try {
var r = document.createRange(); r.selectNodeContents(val);
var s = window.getSelection(); s.removeAllRanges(); s.addRange(r); done();
} catch (e2) {}
});
}
} catch (e) {}
}
overlay.querySelector(".hbp-close").addEventListener("click", close);
overlay.addEventListener("click", function (e) { if (e.target === overlay) close(); });
document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
overlay.querySelector('[data-next="email"]').addEventListener("click", function () { setStep("email"); });
overlay.querySelector("#hbpForm").addEventListener("submit", function (e) {
e.preventDefault();
var input = this.querySelector(".hbp-input");
if (!input.checkValidity()) { input.reportValidity(); return; }
captured.email = input.value.trim();
// The capture is still deferred to the SMS step / skip so the welcome email
// fires exactly once — but close() now also settles it, so bailing here no
// longer throws the email away (see finishSignup).
setStep("sms");
});
// Live rung update as they type. `input` covers typing, paste and autofill.
overlay.querySelector(".hbp-phone").addEventListener("input", function () {
renderLadder(/\d/.test(this.value || ""));
});
overlay.querySelector("#hbpFormSms").addEventListener("submit", function (e) {
e.preventDefault();
var input = this.querySelector(".hbp-phone");
var cc = this.querySelector(".hbp-cc").value;
var digits = (input.value || "").replace(/\D/g, "");
var attrs = { email: captured.email };
if (digits) attrs.phone = cc + digits;
finishSignup(attrs);
setStep("success");
});
overlay.querySelector("[data-skip]").addEventListener("click", function () {
finishSignup({ email: captured.email });
setStep("success");
});
(function () {
var box = overlay.querySelector("#hbpScratch");
var canvas = overlay.querySelector("#hbpCanvas");
var claim = overlay.querySelector(".hbp-claim");
var ctx = canvas.getContext && canvas.getContext("2d", { willReadFrequently: true });
var drawing = false, revealed = false;
function paint() {
if (!ctx) return;
var w = canvas.width, h = canvas.height, dpr = window.devicePixelRatio || 1;
ctx.globalCompositeOperation = "source-over";
ctx.clearRect(0, 0, w, h);
ctx.fillStyle = "#FFF4B3"; ctx.fillRect(0, 0, w, h);
ctx.textAlign = "center"; ctx.textBaseline = "middle";
ctx.font = "800 " + (h * 0.62) + "px 'TAY Milkbar','Baloo 2','Arial Black',sans-serif";
ctx.fillStyle = "rgba(0,7,14,.06)"; ctx.fillText("WIN", w / 2, h / 2 + h * 0.08);
ctx.font = "800 " + Math.round(22 * dpr) + "px 'TAY Milkbar','Baloo 2','Arial Black',sans-serif";
ctx.fillStyle = "rgba(0,7,14,.78)"; ctx.fillText("SCRATCH HERE", w / 2, h / 2);
}
function size() {
if (!ctx) return;
var dpr = window.devicePixelRatio || 1, r = box.getBoundingClientRect();
if (!r.width || !r.height) return;
canvas.width = Math.round(r.width * dpr); canvas.height = Math.round(r.height * dpr);
paint();
}
function pt(e) { var r = canvas.getBoundingClientRect(); return { x: (e.clientX - r.left) * (canvas.width / r.width), y: (e.clientY - r.top) * (canvas.height / r.height) }; }
function erase(p) { var dpr = window.devicePixelRatio || 1; ctx.globalCompositeOperation = "destination-out"; ctx.beginPath(); ctx.arc(p.x, p.y, 26 * dpr, 0, Math.PI * 2); ctx.fill(); }
function pct() { var d = ctx.getImageData(0, 0, canvas.width, canvas.height).data, c = 0, t = 0; for (var i = 3; i < d.length; i += 320) { t++; if (d[i] === 0) c++; } return t ? c / t : 0; }
function reveal() { if (revealed) return; revealed = true; box.classList.add("done"); claim.classList.remove("hide"); }
if (ctx) {
canvas.addEventListener("pointerdown", function (e) { if (revealed) return; drawing = true; try { canvas.setPointerCapture(e.pointerId); } catch (x) {} erase(pt(e)); e.preventDefault(); });
canvas.addEventListener("pointermove", function (e) { if (!drawing || revealed) return; erase(pt(e)); if (pct() > 0.5) reveal(); e.preventDefault(); });
window.addEventListener("pointerup", function () { if (!drawing) return; drawing = false; if (!revealed && pct() > 0.4) reveal(); });
window.addEventListener("resize", function () { if (!revealed) size(); });
}
overlay.__hbpSizeCanvas = size;
})();
function shouldShow() {
if (window.Shopify && Shopify.designMode) return false;       // not while editing in the customizer
// Pages that run their own signup (the flavor-drop LP) set this before we boot.
// Two competing asks for two different offers on one screen wins neither.
if (window.HBP_DISABLE_POPUP) return false;
try { if (localStorage.getItem("hbp_signed")) return false; } catch (e) {}
try { if (sessionStorage.getItem("hbp_closed")) return false; } catch (e) {}
return true;
}
function boot() {
if (!shouldShow()) {
// Closed earlier this session: don't reopen uninvited, but do offer the way back.
var closedEarlier = false;
try { closedEarlier = !!sessionStorage.getItem("hbp_closed"); } catch (e) {}
if (closedEarlier) showReopener();
return;
}
// The config request starts NOW, in parallel with the delay — not after it. By the
// time the popup is due (1.5s) the variant copy is already applied, so nobody sees
// the default copy flash and get swapped underneath them. loadVariant() never
// rejects and is bounded by its own timeout, so the popup opens either way.
var ready = loadVariant();
setTimeout(function () {
ready.then(function () {
open();
if (overlay.__hbpSizeCanvas) overlay.__hbpSizeCanvas();
});
}, CFG.DELAY_MS);
}
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
else boot();
})()
